const sortResponsesByDate = (responses) => {
  return responses.sort((a, b) => {
    return new Date(a.date_completed) - new Date(b.date_completed);
  });
};

/**
 * Returns responses that match the given prompt, classroom, and article id
 * @param {array} studentWriteResponses
 * @param {number} articleId
 * @param {object} promptId
 * @param {number} classroomId
 * @returns {array}
 */
const getRelevantWritePromptResponses = (
  studentWriteResponses,
  articleId,
  promptId,
  classroomId,
) => {
  if (!studentWriteResponses) return [];
  /**
   * Relevant responses should match the current prompt displayed,
   * the classroom selected, and the current article level.
   */
  const filteredWriteResponses = studentWriteResponses.filter((response) => {
    const hasMatchingClassroom = classroomId
      ? response.classroom.id === parseInt(classroomId) ||
        response.classroom.classroom_id === classroomId
      : true;
    return (
      response.prompt.content_id === promptId &&
      response.article.id === articleId &&
      hasMatchingClassroom
    );
  });

  // Return responses ordered by date completed/submitted.
  return sortResponsesByDate(filteredWriteResponses);
};

export default getRelevantWritePromptResponses;
